//pnl-page.js
import React from 'react'
import {
	PageWrapper,
	ScorecardHeader,
	ExecutiveLinks,
} from '../../../components'
// import TopMenu from '../../../components/page-components/executive/pnl/top-menu'
import SankeyChart from '../../../components/UIElements/charts/sankey-chart'

// const nodeOrder = [
// 	'COGS',
// 	'MATL',
// 	'LABOR',
// 	'GROSS',
// 	'OPEX',
// 	'INCOME',
// 	'REV', // You can include 'REV' to be safe or leave it out since it's the source node
// ]
const nodeOrder = [
	'Revenue',
	'Cost of Goods Sold',
	'Mat',
	'Labor',
	'Gross Profit',
	'Operating Expenses',
	'Net Income',
]

const data = {
	nodes: [
		{ id: 'REV', name: 'Revenue' },
		{ id: 'COGS', name: 'Cost of Goods Sold' },
		{ id: 'GROSS', name: 'Gross Profit' },
		{ id: 'OPEX', name: 'Operating Expenses' },
		{ id: 'INCOME', name: 'Net Income' },
		{ id: 'MATL', name: 'Mat' },
		{ id: 'LABOR', name: 'Labor' },
	],

	links: [
		{ source: 'REV', target: 'COGS', value: 100000 },
		{ source: 'REV', target: 'GROSS', value: 60000 },
		{ source: 'COGS', target: 'MATL', value: 50000 },
		{ source: 'COGS', target: 'LABOR', value: 50000 },
		{ source: 'GROSS', target: 'OPEX', value: 40000 },
		{ source: 'GROSS', target: 'INCOME', value: 20000 },
	],
}
const nodeColorMap = {
	Revenue: 'green',
	'Gross Profit': 'green',
	'Net Income': 'green',
	'Cost of Goods Sold': 'red',
	Mat: 'red',
	Labor: 'red',
	'Operating Expenses': 'red',
}
const nodeVerticalOrder = [
	'Revenue',
	'Cost of Goods Sold',
	'Mat',
	'Labor',
	'Gross Profit',
	'Operating Expenses',
	'Net Income',
]

const PnlPage = () => {
	const idToIndexMap = {}
	data.nodes.forEach((node, index) => {
		idToIndexMap[node.id] = index
	})

	const formattedLinks = data.links.map((link) => ({
		...link,
		source:
			typeof link.source === 'string' ? idToIndexMap[link.source] : link.source,
		target:
			typeof link.target === 'string' ? idToIndexMap[link.target] : link.target,
	}))

	return (
		<PageWrapper title='Financials' links={<ExecutiveLinks />}>
			<ScorecardHeader title='Income Statement Metrics' />

			<SankeyChart
				data={{ nodes: data.nodes, links: formattedLinks }}
				nodeColorMap={nodeColorMap}
				nodeOrder={nodeOrder}
			/>
		</PageWrapper>
	)
}

export default PnlPage
